import * as React from 'react'

/**
 * @description RubleHouse icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RubleHouse } from '@sravni/design-system-icons'
 *
 * <RubleHouse />
 * ```
 */
export const RubleHouse = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="RubleHouse" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m2.403 9.444 7.598-6.927a1.064 1.064 0 0 1 1.471 0l7.598 6.927"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M17.736 8v8.572c0 .789-.626 1.428-1.4 1.428h-11.2c-.773 0-1.4-.64-1.4-1.428V8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M9.387 15.667a.563.563 0 0 1-.562-.563V8a1 1 0 0 1 1-1h.684c1.093 0 1.902.214 2.427.643.534.43.8 1.052.8 1.87 0 .55-.129 1.023-.387 1.42-.259.388-.643.688-1.151.898-.5.21-1.122.316-1.864.316H9.95v2.957c0 .31-.252.563-.563.563Zm-1.256-1.651a.394.394 0 1 1 0-.79h3.489a.394.394 0 1 1 0 .79H8.13Zm.067-1.87a.461.461 0 0 1 0-.922h1.736v.923H8.198Zm1.974-.922c.323 0 .938-.053 1.288-.158.358-.105.634-.279.825-.522.192-.242.288-.574.288-.995 0-.55-.175-.959-.525-1.226-.35-.267-.897-.4-1.639-.4h-.259a.2.2 0 0 0-.2.2v2.901c0 .11.06.2.17.2h.052Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".3"
      strokeLinejoin="round"
    />
  </svg>
))
